import React from "react"
import { MdKeyboardArrowRight, MdRefresh } from "react-icons/md"

import { StockItem } from "../../../../../@shared/apis/wowPartner"
import { useSchedule } from "../../../../../@shared/contexts"
import { usePartnerStore } from "../../../../../@shared/stores/partnerStore"
import { useAiIssueCatchStore } from "../../../../../@shared/stores/sidebarStore"
import TradeItem from "./TradeItem"

interface Props {
  isActive: boolean
  handleRefresh: () => void
}

const TradeItemList = ({ isActive, handleRefresh }: Props) => {
  const { schedule } = useSchedule()
  const streamerUsername = schedule?.user.username
  const { isOpen } = useAiIssueCatchStore()
  const { partnerStockList } = usePartnerStore()

  const handleClickMore = () => {
    window.open(partnerStockList.boardUrl, "_blank")
  }

  if (!isActive) {
    return null
  }

  if (partnerStockList.isView === "N") {
    return null
  }

  return (
    <div
      className="chatB"
      style={{
        height: `calc(100% - ${isOpen ? 162 : 54}px)`,
      }}
    >
      <div className="inner">
        <div className="tradeItemList">
          {partnerStockList?.stockItemList.map((stockItem: StockItem) => (
            <TradeItem
              name={stockItem.stockName}
              price={stockItem.currentPrice}
              code={stockItem.stdStockCode}
              isNew={stockItem.isNew === "Y"}
              itemSeq={stockItem.itemSeq}
              chgType={stockItem.chgType}
              losscutPrice={stockItem.losscutPrice}
            />
          ))}
          <div className={"buttonB"}>
            <div className="showAll" onClick={handleRefresh}>
              새로고침
              <MdRefresh className={"buttonImage"} size={18} />
            </div>
            {partnerStockList.boardUrl && (
              <div className="showAll" onClick={handleClickMore}>
                전체보기
                <MdKeyboardArrowRight className={"buttonImage"} size={22} />
              </div>
            )}
          </div>
          {partnerStockList.baseDatetime && (
            <div className="updatedAt">
              현재가 기준일 : {partnerStockList?.baseDatetime}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default TradeItemList
